import React, { useEffect, useState } from 'react';
import TextAnimation from '../../signup-form/user-experience-components/TextAnimation';
import Button from '../../../components/button/Button';
import { Mixpanel } from '../../../analytics/Mixpanel';

type Props = {
	onContinue: () => void;
};

const ChallengeObWelcome: React.FC<Props> = ({ onContinue }) => {
	const onContinueTap = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Do it anytime, anywhere at your convenience',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
		onContinue();
	};

	useEffect(() => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: 'Do it anytime, anywhere at your convenience',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
	}, []);

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				height: '80%',
			}}>
			<TextAnimation
				style={{
					color: '#1B1625',
					textAlign: 'center',
					fontFamily: 'Galaxie-Copernicus-Book',
					fontSize: '24px',
					fontStyle: 'normal',
					width: '100%',
					fontWeight: 400,
					lineHeight: '32px',
				}}
				startAnimation={true}
				onAnimationComplete={() => {}}
				title={'Do it anytime, anywhere at your convenience'}
			/>
			<Button
				isSticky={true}
				style={{
					alignSelf: 'center',
					marginBottom: '24px',
					width: 'calc(100% - 56px)',
					background:
						'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
				}}
				onClick={onContinueTap}
				label={'Continue'}></Button>
		</div>
	);
};

export default ChallengeObWelcome;
